import { render } from "./login.web.vue?vue&type=template&id=7b8f31f2&ts=true"
import script from "./login.web.vue?vue&type=script&lang=ts&scoped=true"
export * from "./login.web.vue?vue&type=script&lang=ts&scoped=true"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__